<script>
    import { onMount } from 'svelte';
    import { t } from '../../i18n';

    export let data = [];

    let tableElement;
    let error = null;

    if(!Array.isArray(data)) error = $t('table.invalid');

    onMount(() => tableElement.dispatchEvent(new CustomEvent('init', {bubbles: true})));

</script>

<style>
    .quotation-remote-refid {display: inline-block; max-width: 220px; overflow: hidden; text-overflow: ellipsis;}
</style>

<div class="table-responsive">

    {#if error}
        <p>{error}</p>
    {:else}

        <table bind:this={tableElement}   class="table invoice-data-table dt-responsive nowrap" data-ordering="false" style="width:100%">
            <thead>
            <tr>
                <th></th>
                <th><span class="align-middle">{$t('table.invoice')}</span></th>
                <th>{$t('table.id')}</th>
                <th>{$t('table.your_ref')}</th>
                <th>{$t('table.date')}</th>
                <th>{$t('table.contact')}</th>
                <th>{$t('table.status')}</th>
                <th>{$t('table.action')}</th>
            </tr>
            </thead>
            <tbody>

            {#each data as row}
                {@const openUrl = '#/quotation/' + row.id}
                <tr>
                    <td></td>
                    <td>
                        <a href="{openUrl}">{row.refid_remote || row.name}</a>
                    </td>
                    <td>
                        <span class="quotation-refid">
                            <a href="{openUrl}">{row.refid || row.id}</a>
                        </span>
                    </td>
                    <td><span class="quotation-remote-refid" title="{row.refid_remote || row.name}">{row.refid_remote || row.name}</span></td>
                    <td><small class="text-muted">{row.date}</small></td>
                    <td>
                        {#if row.contact}
                        <span class="bullet bullet-success bullet-sm"></span>
                        <small class="text-muted">{row.contact}</small>
                        {/if}
                    </td>

                    <td>
                        {#if row.archived==1}
                            <span class="badge badge-light badge-pill">{$t('status.archived')}</span>
                        {:else if row.ga==1}
                            <span class="badge badge-light-success badge-pill">{$t('status.go_ahead')}</span>
                        {:else}
                            <span class="badge badge-light-warning badge-pill">{$t('status.ongoing')}</span>
                        {/if}
                    </td>

                    <td>
                        <div class="invoice-action">
                            <a href="{openUrl}" class="invoice-action-view mr-1"><i class="bx bx-show-alt"></i></a>
                            <a href="{openUrl}" class="invoice-action-edit cursor-pointer"><i class="bx bx-edit"></i></a>
                        </div>
                    </td>
                </tr>
            {/each}





            </tbody>
        </table>

    {/if}
</div>